"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _addCdkey = _interopRequireDefault(require("@/views/product/components/addCdkey.vue"));
var _addCloudDisk = _interopRequireDefault(require("@/views/product/components/addCloudDisk.vue"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _product = require("@/api/product");
var _utils = require("@/utils");
var _product2 = _interopRequireDefault(require("@/mixins/product"));
var _default3 = require("../creatProduct/default");
var _cdkeyLibrary = _interopRequireDefault(require("@/views/product/components/cdkeyLibrary"));
var _reservationStockDialog = _interopRequireDefault(require("./reservationStockDialog.vue"));
var _validate = require("@/utils/validate");
var _TableHeadList = require("../creatProduct/TableHeadList.js");
var _productEnums = require("@/enums/productEnums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'creatAttr',
  mixins: [_product2.default],
  //此js存放商品的部分函数方法
  components: {
    draggable: _vuedraggable.default,
    addCdkey: _addCdkey.default,
    addCloudDisk: _addCloudDisk.default,
    CdkeyLibrary: _cdkeyLibrary.default,
    reservationStockDialog: _reservationStockDialog.default
  },
  computed: {
    tableAttrValue: function tableAttrValue() {
      var obj = Object.assign({}, _default3.defaultObj.attrValueList[0]);
      delete obj.isShow;
      delete obj.image;
      delete obj.brokerage;
      delete obj.brokerageTwo;
      delete obj.cdkeyId;
      delete obj.expand;
      delete obj.cdkeyLibraryName;
      delete obj.attrValueReservationList;
      if (!this.formValidate.isPaidMember) {
        delete obj.vipPrice;
      } else {
        obj.vipPrice = Object.assign({}, _default3.defaultObj.attrValueList[0]).vipPrice;
      }
      if (this.formValidate.type === 2) {
        delete obj.itemNumber;
      }
      if (this.formValidate.type === 5) {
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      if (this.formValidate.type === 6) {
        delete obj.volume;
        delete obj.weight;
        delete obj.itemNumber;
      }
      if (this.formValidate.type === 7) {
        delete obj.volume;
        delete obj.weight;
        delete obj.stock;
        delete obj.itemNumber;
      }
      return obj;
    }
  },
  data: function data() {
    return {
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      carMytabIndex: 0,
      carMytabName: '',
      cdkeyId: null,
      //卡密库id
      cdkeyLibraryInfo: null,
      //卡密库对象
      cloudDisk: '',
      //云盘地址
      showAll: false,
      formValidate: this.value,
      ruleList: [],
      // // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      formDynamics: {
        ruleName: '',
        ruleValue: []
      },
      tableFrom: {
        page: 1,
        limit: 9999,
        keywords: ''
      },
      columnsInstalM: [],
      changeAttrValue: '',
      //修改的规格值
      currentIndex: 0,
      canSel: true,
      // 规格图片添加判断
      tableKey: 0,
      // timeCheckGroup: [], //自动划分当前选中的元素
      timeCheckAllClone: [],
      //自动划分克隆全部选中的元素
      timeDataClone: [],
      //自动划分时的库存（为了切换时段划分时，可以复原之前选中的数据）
      // customizeTimeClone: [['', '']], // 自定义划分库存
      // reservationTime: ['', ''], // 自动划分起止时间
      timeCheckAll: false,
      //是否全选
      // timeSlotList: [], // 生成的时间段
      isIndeterminate: false,
      dialogVisible: false,
      // 预约弹窗
      reservationData: [],
      // 设置预约库存
      customizeTimeData: [],
      //自定义时间段
      isCustomize: false,
      //自定义时间段开关，true自定义开关开启
      isFlashing: false
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 生成规格表格中的头部标题
    manyTabDate: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //生成规格的表格中填写的值
    formThead: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    //生成表格的头部标题
    manyTabTit: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 单规格
    OneattrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 多规格
    ManyAttrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //批量添加规格
    oneFormBatch: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    formValidate: {
      handler: function handler(newVal) {
        this.formValidate = newVal;
        // this.$emit('input', newVal);
      } // deep: true,
    }
  },
  mounted: function mounted() {
    this.getTimeCheckGroup();
    //预约商品
    if (this.$route.params.id && this.$route.params.id != 0 && this.formValidate.type === 7) {
      this.getReservationInfosss();
    }
    if (this.formValidate.specType) this.productGetRule(); //加载商品规格选项

    if (this.formValidate.specType && (this.$route.params.id && this.$route.params.id != 0 || this.$route.params.isCopy === '1')) {
      // this.formValidate.attrs = this.formValidate.attrList.map((i) => {
      //   return {
      //     value: i.attributeName,
      //     detail: i.optionList.map((val) => ({ value: val.optionName, image: val.image })),
      //     add_pic: i.isShowImage ? 1 : 0,
      //   };
      // });
      this.createBnt = true;
      // 采集商品只有规格，没有规格列表，这里判断使用 方法，attrValueList.length为0，走生成规格方法
      if (this.formValidate.attrValueList.length) {
        this.generateHeader(this.formValidate.attrs);
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
    }
  },
  methods: {
    /***************预约的业务*****************/
    // 编辑获取预约商品详情数据
    getReservationInfosss: function getReservationInfosss() {
      //预约商品时段划分类型：1-自动，2-自定义 , 编辑中赋值设置的时间段
      var timeSlotLists = this.formValidate.timeSlotList.map(function (item) {
        return item.timeSlot;
      });
      if (this.formValidate.supplementReservation.timeSlotClassifyType === 1) {
        //  this.formValidate.timeSlotAutomatic = this.formValidate.timeSlotList;
        //   this.isCustomize = false;
        // this.timeCheckGroup = timeSlotLists;
      } else {
        this.isCustomize = true;
        var formattedTimes = timeSlotLists.map(function (time) {
          return time.split('-');
        });
        //    this.formValidate.temporaryData.customizeTimeClone = formattedTimes;
        this.customizeTimeData = timeSlotLists;
      }
    },
    // 自定义添加时段；
    addTime: function addTime() {
      if (this.isDisabled) return;
      var customizeTime = this.formValidate.temporaryData.customizeTimeClone;
      for (var i = 0; i < customizeTime.length; i++) {
        if (!customizeTime[i][0]) {
          return this.$message.warning('请选择时段');
        }
      }
      if (this.intersection(customizeTime)) {
        return this.$message.warning('时段必须递增无交集');
      }
      this.formValidate.temporaryData.customizeTimeClone.push(['', '']);
    },
    // 判断交集和递增；
    intersection: function intersection(customizeTime) {
      var intersection = this.$selfUtil.hasIntersection(customizeTime); //是否有交集
      return intersection;
    },
    // 自定义划分 时间选择
    changeCustomizeTime: function changeCustomizeTime(e) {
      var customizeTime = this.formValidate.temporaryData.customizeTimeClone;
      customizeTime[customizeTime.length - 1] = e;
    },
    closeTime: function closeTime(index) {
      this.formValidate.temporaryData.customizeTimeClone.splice(index, 1);
    },
    //预约设置库存回调
    handleSubmitOk: function handleSubmitOk(data) {
      var _this2 = this;
      if (this.formValidate.specType) {
        this.ManyAttrValue[this.carMytabIndex] = data[0];
        this.$nextTick(function () {
          _this2.$emit('changeOneattrValue', _toConsumableArray(_this2.ManyAttrValue));
        });
      } else {
        this.$nextTick(function () {
          _this2.$emit('changeManyAttrValue', _toConsumableArray(data));
        });
      }
      this.dialogVisible = false;
    },
    // 关闭弹窗
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 获取可预约数量的数据
    gettReservationNumData: function gettReservationNumData(index, attrValue, name) {
      var timeList = this.isCustomize ? this.customizeTimeData : this.timeCheckGroup;
      // 设置数量跟时间，用一个updateList函数复用批量和单个逻辑。
      var updateList = function updateList(item) {
        var oldList = item.attrValueReservationList || [];
        item.attrValueReservationList = timeList.map(function (time) {
          // 查找有没有时间，有的话就是设置过数量的，没有的话就默认为0
          var old = oldList.find(function (i) {
            return i.timeSlot === time;
          });
          return {
            stock: old ? old.stock : 0,
            timeSlot: time
          };
        });
      };
      var attrValueNewBatch = this.formValidate.specType ? _toConsumableArray(attrValue.slice(1)) : _toConsumableArray(attrValue); // 批量使用的数组
      var attrValueNew = _toConsumableArray(attrValue); // 单条使用的数组

      // batch为批量，批量与单独设置的区别，批量设置的是全部的sku，单独设置的是当前这条的属性
      if (name === 'batch') {
        attrValueNewBatch.forEach(updateList);
        this.reservationData = attrValueNewBatch;
      } else {
        updateList(attrValueNew[index]);
        this.reservationData = [attrValueNew[index]];
      }
    },
    // 设置可预约的数量
    handleSetReservationNum: (0, _validate.Debounce)(function (index, attrValue, name) {
      var _this3 = this;
      // return;
      // this.isCustomize为true是自定义划分，false是自动划分
      var timeList = this.isCustomize ? this.customizeTimeData : this.timeCheckGroup;
      if (timeList.length === 0) {
        this.isFlashing = true;
        this.$message.warning('请先设置时段划分');
        setTimeout(function () {
          _this3.isFlashing = false; // 可选：自动停止闪烁
        }, 5000); // 闪烁时间，这里设置为2秒
        return;
      }
      this.gettReservationNumData(index, attrValue, name);
      this.carMytabIndex = index;
      this.carMytabName = name;
      this.dialogVisible = true;
    }),
    // 设置预约库存弹窗生成时间、库存，只在新增中调用， 设置数量跟时间，用一个updateList函数复用批量和单个逻辑。
    updateList: function updateList(item) {
      var oldList = item.attrValueReservationList || [];
      item.attrValueReservationList = timeList.map(function (time) {
        // 查找有没有时间，有的话就是设置过数量的，没有的话就默认为0
        var old = oldList.find(function (i) {
          return i.timeSlot === time;
        });
        return {
          stock: old ? old.stock : 0,
          timeSlot: time
        };
      });
    },
    //全选按钮
    handleCheckAll: function handleCheckAll(val) {
      this.formValidate.timeSlotAutomatic.forEach(function (item) {
        item.isCheck = val ? 1 : 0;
      });
      this.isIndeterminate = false;
      this.getTimeCheckGroup();
    },
    // 单独勾选按钮
    checkAllGroupChange: function checkAllGroupChange(value) {
      var checkedCount = value.length;
      this.timeCheckAll = checkedCount === this.formValidate.timeSlotAutomatic.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.formValidate.timeSlotAutomatic.length;
      this.setTimeSlotAutomatic(value);
    },
    // 获取选中的对象
    setTimeSlotAutomatic: function setTimeSlotAutomatic(value) {
      this.formValidate.timeSlotAutomatic.forEach(function (item) {
        item.isCheck = value.includes(item.timeSlot) ? 1 : 0;
      });
    },
    // 设置时间段展示
    /**
     * 生成时间段区间数组
     * @param {string} start - 起始时间 "HH:mm"
     * @param {string} end - 结束时间 "HH:mm"
     * @param {number} interval - 间隔分钟数
     * @returns {string[]} 时间段区间数组
     */
    generateTimeRanges: function generateTimeRanges(start, end, interval) {
      var result = [];
      var _start$split$map = start.split(':').map(Number),
        _start$split$map2 = _slicedToArray(_start$split$map, 2),
        sh = _start$split$map2[0],
        sm = _start$split$map2[1];
      var _end$split$map = end.split(':').map(Number),
        _end$split$map2 = _slicedToArray(_end$split$map, 2),
        eh = _end$split$map2[0],
        em = _end$split$map2[1];
      var startMinutes = sh * 60 + sm;
      var endMinutes = eh * 60 + em;
      while (startMinutes + interval <= endMinutes) {
        var h1 = String(Math.floor(startMinutes / 60)).padStart(2, '0');
        var m1 = String(startMinutes % 60).padStart(2, '0');
        var h2 = String(Math.floor((startMinutes + interval) / 60)).padStart(2, '0');
        var m2 = String((startMinutes + interval) % 60).padStart(2, '0');
        result.push({
          timeSlot: "".concat(h1, ":").concat(m1, "-").concat(h2, ":").concat(m2),
          isCheck: 1
        });
        startMinutes += interval;
      }
      return result;
    },
    // 保存生成时间段
    generateTimeSlots: function generateTimeSlots() {
      this.isCustomize = false;
      if (!this.formValidate.temporaryData.reservationTime[0]) return this.$message.warning('起止时间段不能为空');
      var start_time = this.formValidate.temporaryData.reservationTime[0];
      var end_time = this.formValidate.temporaryData.reservationTime[1];
      var slots = this.generateTimeRanges(start_time, end_time, this.formValidate.supplementReservation.timeSlotSpan);
      // 按时间正序排序
      slots.sort(function (a, b) {
        var getStart = function getStart(str) {
          var _str$timeSlot$split$ = str.timeSlot.split('-')[0].split(':').map(Number),
            _str$timeSlot$split$2 = _slicedToArray(_str$timeSlot$split$, 2),
            h = _str$timeSlot$split$2[0],
            m = _str$timeSlot$split$2[1];
          return h * 60 + m;
        };
        return getStart(a) - getStart(b);
      });
      this.formValidate.timeSlotAutomatic = slots;
      var lal = slots.filter(function (item) {
        return item.isCheck === 1;
      }).map(function (item) {
        return item.timeSlot;
      });
      this.timeCheckGroup = lal;
      this.isIndeterminate = false;
      this.timeCheckAll = true;
      var attrValue = this.formValidate.specType ? this.ManyAttrValue : this.OneattrValue;
      this.gettReservationNumData(0, attrValue, 'batch');
      this.$message.success('设置成功');
    },
    // 选择起止时间
    reservationTimesChange: function reservationTimesChange(value) {
      // 判断选择的时间间隔不能小于10分钟
      if (value && value.length === 2) {
        var startTime = new Date("1970-01-01T".concat(value[0]));
        var endTime = new Date("1970-01-01T".concat(value[1]));
        var diff = (endTime - startTime) / 1000 / 60; // 转换为分钟
        if (diff < 10) {
          this.$message.error('时间间隔不能小于10分钟');
          // 可以选择重置时间范围或者调整其中一个时间值以符合要求
          this.formValidate.temporaryData.reservationTime = ['', '']; // 清空时间范围，让用户重新选择
        } else {
          this.formValidate.supplementReservation.timeSlotStartEndTime = this.formValidate.temporaryData.reservationTime.join(',');
        }
      }
    },
    // 自定义划分设置按钮
    setCustomizeTime: function setCustomizeTime() {
      var _this4 = this;
      for (var i = 0; i < this.formValidate.temporaryData.customizeTimeClone.length; i++) {
        if (!this.formValidate.temporaryData.customizeTimeClone[i][0]) {
          return this.$message.error('请选择时段');
        }
      }
      if (this.intersection(this.formValidate.temporaryData.customizeTimeClone)) {
        return this.$message.error('时段必须无重叠');
      }
      this.customizeTimeData = [];
      this.formValidate.timeSlotCustomize = [];
      this.formValidate.temporaryData.customizeTimeClone.forEach(function (item) {
        _this4.customizeTimeData.push("".concat(item[0], "-").concat(item[1]));
        _this4.formValidate.timeSlotCustomize.push({
          timeSlot: "".concat(item[0], "-").concat(item[1]),
          isCheck: 1
        });
      });
      // 按时间正序排序
      this.customizeTimeData.sort(function (a, b) {
        var getStart = function getStart(str) {
          var _str$split$0$split$ma = str.split('-')[0].split(':').map(Number),
            _str$split$0$split$ma2 = _slicedToArray(_str$split$0$split$ma, 2),
            h = _str$split$0$split$ma2[0],
            m = _str$split$0$split$ma2[1];
          return h * 60 + m;
        };
        return getStart(a) - getStart(b);
      });
      this.isCustomize = true; //自定义划分开启
      var attrValue = this.formValidate.specType ? this.ManyAttrValue : this.OneattrValue;
      this.gettReservationNumData(0, attrValue, 'batch');
      this.$message.success('设置成功');
      this.$emit('input', this.formValidate);
    },
    /***************预约的业务*****************/handleShowPop: function handleShowPop(index) {
      this.$refs['inputRef_' + index][0].focus();
    },
    // 删除属性
    handleRemove2: function handleRemove2(item, index, val) {
      item.splice(index, 1);
      this.delAttrTable(val);
    },
    // 新增规格
    handleAddRole: function handleAddRole() {
      var _this5 = this;
      var data = {
        value: this.formDynamic.attrsName,
        add_pic: 0,
        detail: []
      };
      //  let attr = []
      //  attr.push(data);
      // this.$set(this.formValidate, 'attrs',attr)

      this.$nextTick(function () {
        _this5.formValidate.attrs.push(data);
        _this5.$emit('changeManyAttrValue', _toConsumableArray(_this5.ManyAttrValue));
        _this5.$emit('input', _this5.formValidate);
      });
    },
    // 规格名称改变
    attrChangeValue: function attrChangeValue(i, val) {
      var _this6 = this;
      if (val.trim().length && this.formValidate.attrs[i].detail.length) {
        this.generateHeader(this.formValidate.attrs);
        if (this.ManyAttrValue.length) {
          this.ManyAttrValue.map(function (item, i) {
            if (i > 0) {
              if (Object.keys(item.attrValueShow).includes(_this6.changeAttrValue)) {
                item.attrValueShow[val] = item.attrValueShow[_this6.changeAttrValue];
                item[val] = item[_this6.changeAttrValue];
                delete item.attrValueShow[_this6.changeAttrValue];
                delete item[_this6.changeAttrValue];
              }
            }
          });
          this.changeAttrValue = val;
        }
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
      // 触发父组件数据同步
      this.$emit('input', this.formValidate);
    },
    // 规格值改变
    attrDetailChangeValue: function attrDetailChangeValue(val, i) {
      var _this7 = this;
      if (this.ManyAttrValue.length) {
        var key = this.formValidate.attrs[i].value;
        this.ManyAttrValue.map(function (item, i) {
          if (i > 0) {
            if (Object.keys(item.attrValueShow).includes(key) && item.attrValueShow[key] === _this7.changeAttrValue) {
              item.attrValueShow[key] = val;
              var index = item.attr_arr.findIndex(function (item) {
                return item === _this7.changeAttrValue;
              });
              item.attr_arr[index] = val;
            }
          }
        });
        this.changeAttrValue = val;
      } else {
        this.generateAttr(this.formValidate.attrs, 1);
      }
      this.$nextTick(function () {
        _this7.$emit('changeManyAttrValue', _toConsumableArray(_this7.ManyAttrValue));
        _this7.$emit('input', _this7.formValidate);
      });
    },
    changeCurrentIndex: function changeCurrentIndex(i) {
      this.currentIndex = i;
    },
    // 新增一条属性
    addOneAttr: function addOneAttr(val, val2) {
      this.generateAttr(this.formValidate.attrs, val2);
    },
    handleFocus: function handleFocus(val) {
      this.changeAttrValue = val;
    },
    handleBlur: function handleBlur() {
      this.changeAttrValue = '';
    },
    // 规格拖拽排序后
    onMoveSpec: function onMoveSpec() {
      this.generateAttr(this.formValidate.attrs);
    },
    handleRemoveImg: function handleRemoveImg(item) {
      item.image = '';
    },
    // 合并单元格
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0 && rowIndex > 0) {
        var lable = column.label;
        //这里判断第几列需要合并
        var tagFamily = this.ManyAttrValue[rowIndex].attrValueShow[lable];
        var index = this.ManyAttrValue.findIndex(function (item, index) {
          if (index > 0) return item.attrValueShow[lable] == tagFamily;
        });
        if (rowIndex == index) {
          var len = 1;
          for (var i = index + 1; i < this.ManyAttrValue.length; i++) {
            if (this.ManyAttrValue[i].attrValueShow[lable] !== tagFamily) {
              break;
            }
            len++;
          }
          return {
            rowspan: len,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    /*
     * 生成属性
     * @param {Array} data 规格数据
     * */
    generateAttr: function generateAttr(data, val) {
      var _this8 = this;
      // 判断该段Js执行时间
      this.generateHeader(data);
      var combinations = this.generateCombinations(data);
      var rows = combinations.map(function (combination) {
        var row = {
          attr_arr: combination,
          attrValueShow: {},
          image: '',
          price: 0.01,
          vipPrice: 0.01,
          cost: 0.01,
          otPrice: 0.01,
          barCode: '',
          itemNumber: '',
          stock: 0,
          weight: 0,
          volume: 0,
          brokerage: 0,
          brokerageTwo: 0,
          cdkeyId: null,
          cdkeyLibraryName: '',
          expand: '',
          isShow: true,
          attrValueReservationList: []
        };
        for (var i = 0; i < combination.length; i++) {
          var value = combination[i];
          _this8.$set(row, data[i].value, value);
          _this8.$set(row, 'title', data[i].value);
          _this8.$set(row, 'key', data[i].value);
          _this8.$set(row.attrValueShow, data[i].value, value);
          // 如果manyFormValidate中存在该属性值，则赋值
          for (var k = 0; k < _this8.ManyAttrValue.length; k++) {
            var manyItem = _this8.ManyAttrValue[k];
            // 对比两个数组是否完全相等
            if (k > 0 && manyItem.attr_arr && (0, _utils.arraysEqual)(manyItem.attr_arr, combination)) {
              Object.assign(row, {
                price: manyItem.price,
                cost: manyItem.cost,
                otPrice: manyItem.otPrice,
                stock: manyItem.stock,
                image: manyItem.image,
                sku: manyItem.sku || '',
                weight: manyItem.weight || 0,
                isDefault: manyItem.isDefault || 0,
                volume: manyItem.volume || 0,
                barCode: manyItem.barCode || '',
                itemNumber: manyItem.itemNumber || '',
                brokerage: manyItem.brokerage,
                brokerageTwo: manyItem.brokerageTwo,
                vipPrice: manyItem.vipPrice,
                attrValueReservationList: manyItem.attrValueReservationList || [],
                cdkeyId: manyItem.cdkeyId || '',
                cdkey: manyItem.cdkey || {},
                expand: manyItem.expand || '',
                cdkeyLibraryName: manyItem.cdkeyLibraryName || ''
              });
            } else if (k > 0 && manyItem.attr_arr.length && data[i].add_pic && combination.includes(val)) {
              // data[i].detail中的value是规格值 存在与 manyItem.attr_arr 中的某一项
              data[i].detail.map(function (e, ii) {
                combination.includes(e.value) && _this8.$set(row, 'image', e.image);
              });
            }
          }
        }
        return row;
      });
      this.$nextTick(function () {
        // rows数组第一项 新增默认数据 oneFormBatch
        _this8.$emit('changeManyAttrValue', [].concat(_toConsumableArray(_this8.oneFormBatch), _toConsumableArray(rows)));
      });
    },
    //分佣设置 会员商品操作
    changeAttrVal: function changeAttrVal() {
      this.generateHeader(this.formValidate.attrs);
    },
    // 生成商品规格表头
    generateHeader: function generateHeader(data) {
      var specificationsColumns = data.map(function (item) {
        return {
          title: item.value,
          key: item.value,
          minWidth: 200,
          fixed: 'left'
        };
      });
      var arr;
      //云盘商品
      if (this.formValidate.type == this.OrderSecondTypeEnum.CloudDrive) {
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead));
        }
        // 找到slot 等于 fictitious 将title改为规格名称
        this.formValidate.header.map(function (item) {
          if (item.slot === 'fictitious') {
            item.title = '云盘设置';
          }
        });
      } else if (this.formValidate.type == this.OrderSecondTypeEnum.CardPassword) {
        //卡密商品
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.VirtualTableHead2));
        }
      } else if (this.formValidate.type == this.OrderSecondTypeEnum.Fictitious) {
        //虚拟商品
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        }
      } else if (this.formValidate.type == this.OrderSecondTypeEnum.Reservation) {
        // 预约
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.reservationTableHeard));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.reservationTableHeard));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.FictitiousTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.reservationTableHeard));
        }
      } else {
        // 开启分佣设置
        if (this.formValidate.isSub && this.formValidate.isPaidMember) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else if (this.formValidate.isSub) {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else if (this.formValidate.isPaidMember) {
          //开启会员
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.vipPriceTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        } else {
          arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
        }
      }
      this.$set(this.formValidate, 'header', arr);
      this.tableKey += 1;
      this.columnsInstalM = arr;
    },
    // 生成规格组合
    generateCombinations: function generateCombinations(arr) {
      var _this9 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (arr.length === 0) {
        return [prefix];
      }
      var _arr = _toArray(arr),
        first = _arr[0],
        rest = _arr.slice(1);
      return first.detail.flatMap(function (detail) {
        return _this9.generateCombinations(rest, [].concat(_toConsumableArray(prefix), [detail.value]));
      });
    },
    // 另存为模板
    handleSaveAsTemplate: function handleSaveAsTemplate() {
      var _this0 = this;
      this.$prompt('', '请输入模板名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          if (value === null) {
            return '输入不能为空';
          }
          if (value.length > 30) return '输入限制30字以内';
        }
      }).then(function (_ref2) {
        var value = _ref2.value;
        var spec = _this0.formValidate.attrs.map(function (item) {
          return {
            value: item.value,
            detail: item.detail.map(function (e) {
              return e.value;
            })
          };
        });
        var data = {
          id: 0,
          ruleName: value,
          ruleValue: JSON.stringify(spec)
        };
        (0, _product.attrCreatApi)(data).then(function (res) {
          _this0.$message.success('提交成功');
          _this0.productGetRule();
          _this0.clear();
          _this0.loading = false;
          _this0.loadingBtn = false;
        }).catch(function () {
          _this0.loading = false;
          _this0.loadingBtn = false;
        });
      }).catch(function () {});
    },
    // 在规格中选择规格图片
    handleSelImg: function handleSelImg(item) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        item.image = img[0].sattDir;
        _this.changeSpecImg([item.value], img[0].sattDir);
      }, false, 'content');
    },
    changeSpecImg: function changeSpecImg(arr, img) {
      var _this1 = this;
      // 判断是否存在规格图
      var isHas = false;
      for (var i = 1; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.image && this.isSubset(item.attr_arr, arr)) {
          isHas = true;
          break;
        }
      }
      if (isHas) {
        this.$confirm('可以同步修改下方该规格图片，确定要替换吗？', '提示', {
          confirmButtonText: '替换',
          cancelButtonText: '暂不',
          type: 'warning'
        }).then(function () {
          var _iterator = _createForOfIteratorHelper(_this1.ManyAttrValue),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var val = _step.value;
              if (_this1.isSubset(val.attr_arr, arr)) {
                _this1.$set(val, 'image', img);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }).catch(function () {});
      } else {
        var _iterator2 = _createForOfIteratorHelper(this.ManyAttrValue),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var val = _step2.value;
            if (this.isSubset(val.attr_arr, arr)) {
              this.$set(val, 'image', img);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    // 规格图片添加开关
    addPic: function addPic(e, i) {
      var _this10 = this;
      if (e) {
        this.formValidate.attrs.map(function (item, ii) {
          if (ii !== i) {
            _this10.$set(item, 'add_pic', 0);
          }
        });
        this.canSel = false;
      } else {
        this.canSel = true;
      }
    },
    // 生成列表 行 列 数据
    tableCellClassName: function tableCellClassName(_ref3) {
      var row = _ref3.row,
        column = _ref3.column,
        rowIndex = _ref3.rowIndex,
        columnIndex = _ref3.columnIndex;
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex || '';
      column.index = columnIndex;
    },
    //返佣输入
    keyupEventBrokerage: function keyupEventBrokerage(val, index, num) {
      switch (num) {
        case 1:
          this.oneFormBatch[index][val] = this.oneFormBatch[index][val] > 0 ? parseInt(this.oneFormBatch[index][val]) : 0;
          break;
        case 2:
          this.OneattrValue[index][val] = this.OneattrValue[index][val] > 0 ? parseInt(this.OneattrValue[index][val]) : 0;
          break;
        default:
          this.ManyAttrValue[index][val] = this.ManyAttrValue[index][val] > 0 ? parseInt(this.ManyAttrValue[index][val]) : 0;
      }
    },
    // 添加规则；
    addRule: function addRule() {
      var _this = this;
      this.$modalAttr(this.formDynamics, function () {
        _this.productGetRule();
      });
    },
    // 选择规格
    onChangeSpec: function onChangeSpec(num) {
      if (num) {
        this.productGetRule();
        if (this.$route.params.id != 0) this.formValidate.attrs = [];
      } else {
        this.formValidate.attrs = [];
        this.formValidate.attrList = [];
      }
    },
    // 选择属性确认
    confirm: function confirm(name) {
      var _this11 = this;
      this.createBnt = true;
      this.canSel = true;
      this.formValidate.selectRule = name;
      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }
      var dataAttrList = [];
      var dataAttrs = [];
      this.ruleList.forEach(function (item) {
        if (item.ruleName === _this11.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            dataAttrList.push({
              attributeName: i.value,
              optionList: i.detail.map(function (val) {
                return {
                  optionName: val,
                  image: '',
                  sort: 0
                };
              }),
              id: 0,
              isShowImage: false,
              sort: i + 1
            });
            dataAttrs.push({
              value: i.value,
              detail: i.detail.map(function (val) {
                return {
                  value: val,
                  image: ''
                };
              }),
              id: 0,
              add_pic: 0,
              sort: i + 1
            });
          });
        }
        _this11.formValidate.attrList = dataAttrList;
        _this11.formValidate.attrs = dataAttrs;
      });
      // this.attrs.map((item, ii) => {
      //   this.$set(item, 'isShowImage', false);
      // });
      // this.canSel = true;
      this.generateAttr(this.formValidate.attrs);
    },
    // 获取商品属性模板；
    productGetRule: function productGetRule() {
      var _this12 = this;
      (0, _product.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this12.ruleList = list;
      });
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(val) {
      for (var i = 0; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.attr_arr && item.attr_arr.includes(val)) {
          this.ManyAttrValue.splice(i, 1);
          i--;
        }
      }
    },
    isSubset: function isSubset(arr1, arr2) {
      // 将数组转换为 Set，以便进行高效的包含检查
      var set1 = new Set(arr1);
      var set2 = new Set(arr2);

      // 检查 set2 中的每个元素是否都在 set1 中
      var _iterator3 = _createForOfIteratorHelper(set2),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var elem = _step3.value;
          if (!set1.has(elem)) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return true;
    },
    // 切换默认选中规格
    changeDefaultSelect: function changeDefaultSelect(e, index) {
      this.$emit('changeDefault', e, index);
      // 一个开启 其他关闭
      // this.ManyAttrValue.map((item, i) => {
      //   if (i !== index) {
      //     item.isDefault = false;
      //   }
      // });
      // if (e) this.ManyAttrValue[index].isShow = true;
    },
    // 改变是否显示
    changeDefaultShow: function changeDefaultShow(index) {
      // 至少显示一个规格
      if (!this.ManyAttrValue.some(function (item) {
        return item.isShow;
      })) {
        this.ManyAttrValue[index].isShow = true;
        this.$message.error('至少显示一个规格');
      }
      // 如果默认选中开启 则不可隐藏
      if (this.ManyAttrValue[index].isDefault === true) {
        this.ManyAttrValue[index].isShow = true;
        this.$message.error('默认规格不可隐藏');
      }
    },
    // 清空批量规格信息
    batchDel: function batchDel() {
      this.$emit('handleBatchDel');
    },
    // 批量添加
    batchAdd: function batchAdd() {
      var _this13 = this;
      var arr = [];
      var _iterator4 = _createForOfIteratorHelper(this.formValidate.attrs),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var val = _step4.value;
          if (this.oneFormBatch[0][val.value]) {
            arr.push(this.oneFormBatch[0][val.value]);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.ManyAttrValue.forEach(function (val) {
        if (val.attrValueShow) {
          if (arr.length) {
            var attrVal = val.attrValueShow;
            //   let data = Object.values(val.attrValueShow).map((item) => item.val);
            if (_this13.isSubset(Object.values(attrVal), arr)) {
              _this13.batchData(val);
            }
          } else {
            _this13.batchData(val);
          }
        }
      });
    },
    // 批量数据
    batchData: function batchData(val) {
      if (this.oneFormBatch[0].image) this.$set(val, 'image', this.oneFormBatch[0].image);
      if (this.oneFormBatch[0].price > 0) this.$set(val, 'price', this.oneFormBatch[0].price);
      if (this.oneFormBatch[0].cost > 0) this.$set(val, 'cost', this.oneFormBatch[0].cost);
      if (this.oneFormBatch[0].otPrice > 0) this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
      if (this.oneFormBatch[0].barCode) this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
      if (this.oneFormBatch[0].stock >= 0) this.$set(val, 'stock', this.oneFormBatch[0].stock);
      if (this.oneFormBatch[0].weight >= 0) this.$set(val, 'weight', this.oneFormBatch[0].weight);
      if (this.oneFormBatch[0].volume >= 0) this.$set(val, 'volume', this.oneFormBatch[0].volume);
      if (this.oneFormBatch[0].brokerage > 0) this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
      if (this.oneFormBatch[0].brokerageTwo > 0) this.$set(val, 'brokerageTwo', this.oneFormBatch[0].brokerageTwo);
      if (this.oneFormBatch[0].vipPrice > 0) this.$set(val, 'vipPrice', this.oneFormBatch[0].vipPrice);
      if (this.oneFormBatch[0].itemNumber) this.$set(val, 'itemNumber', this.oneFormBatch[0].itemNumber);
    },
    // 添加按钮
    addBtn: function addBtn() {
      this.clearAttr();
      this.isBtn = true;
    },
    clearAttr: function clearAttr() {
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveRole: function handleRemoveRole(index) {
      this.formValidate.attrs.splice(index, 1);
      this.ManyAttrValue.splice(index, 1);
      if (!this.formValidate.attrs.length) {
        this.formValidate.header = [];
        this.ManyAttrValue = [];
      } else {
        this.generateAttr(this.formValidate.attrs);
      }
    },
    // 添加属性
    createAttr: function createAttr(num, idx) {
      var _this14 = this;
      if (num) {
        // 判断是否存在同样数据
        var isExist = this.formValidate.attrs[idx].detail.some(function (item) {
          return item.value === num;
        });
        if (isExist) {
          this.$message.error('规格值已存在');
          return;
        }
        this.formValidate.attrs[idx].detail.push({
          value: num,
          image: ''
        });
        if (this.ManyAttrValue.length) {
          this.addOneAttr(this.formValidate.attrs[idx].value, num);
        } else {
          this.generateAttr(this.formValidate.attrs);
        }
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
        this.clearAttr();
        setTimeout(function () {
          if (_this14.$refs['popoverRef_' + idx]) {
            //重点是以下两句
            _this14.$refs['popoverRef_' + idx][0].doShow(); //打开的
            //重点是以上两句
          }
        }, 20);
      } else {
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
      }
    },
    //清空卡密
    virtualListClear: function virtualListClear() {
      // this.$set(this[this.carMytabName][this.carMytabIndex], 'cdkey', []);
      this[this.carMytabName][this.carMytabIndex].cdkeyId = [];
    },
    //添加倒入卡密的值
    changeVirtual: function changeVirtual(e) {
      this.virtualList = this.virtualList.concat(e);
    },
    closeCloudDisk: function closeCloudDisk() {
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    //确认保存云盘链接
    handlerSubSuccessCloudDisk: function handlerSubSuccessCloudDisk(e) {
      this.cloudDisk = e;
      this[this.carMytabName][this.carMytabIndex].expand = JSON.parse(JSON.stringify(e));
      this.$refs.cloudDiskRef.cloudDiskShow = false;
    },
    //选择卡密库回调
    handlerChangeCdkeyIdSubSuccess: function handlerChangeCdkeyIdSubSuccess(row) {
      this[this.carMytabName][this.carMytabIndex].cdkeyLibraryName = row.name;
      this[this.carMytabName][this.carMytabIndex].cdkeyId = row.id;
      this[this.carMytabName][this.carMytabIndex].stock = row.stock;
    },
    //查看已设置的虚拟商品
    seeVirtually: function seeVirtually(data, name, index, type) {
      this.carMytabName = name;
      this.carMytabIndex = index;
      if (type === 1) {
        this.cloudDisk = data.expand;
        this[this.carMytabName][this.carMytabIndex].expand = data.expand;
        this.$refs.cloudDiskRef.cloudDiskShow = true;
      } else {
        this.cdkeyLibraryInfo = {
          id: data.cdkeyId,
          name: data.cdkeyLibraryName
        };
        this.$refs.cdkeyLibraryRef.cdkeyShow = true;
      }
    },
    // 添加虚拟链接
    handleAddVirtually: function handleAddVirtually(index, name, type) {
      this.carMytabIndex = index;
      this.carMytabName = name;
      //this.virtualListClear();
      if (type === 1) {
        this.cloudDisk = '';
        this.$refs.cloudDiskRef.cloudDiskShow = true;
      } else {
        this.cdkeyLibraryInfo = {};
        this.$refs.cdkeyLibraryRef.cdkeyShow = true;
      }
    }
  }
};